import React from 'react';
import { NavLink } from 'react-router-dom';

import classes from './Navigation.module.scss';

const Navigation = () => {
    return <div className={classes.Navigation}>
        <div className={classes.NavigationItem}><NavLink to="/" exact activeClassName={classes.ActiveLink}>
            Home</NavLink></div>
        <div className={classes.NavigationItem}><NavLink to="/about" exact activeClassName={classes.ActiveLink}>
            About</NavLink></div>
        <div className={classes.NavigationItem}><NavLink to="/participants" exact activeClassName={classes.ActiveLink}>
            Participants</NavLink></div>
        <div className={classes.NavigationItem}><NavLink to="/proceedings" exact activeClassName={classes.ActiveLink}>
            Proceedings</NavLink></div>
        <div className={classes.NavigationItem}><NavLink to="/fees-deadlines" exact activeClassName={classes.ActiveLink}>
            Fees &amp; Deadlines</NavLink></div>
        <div className={classes.NavigationItem}><NavLink to="/schedule" exact activeClassName={classes.ActiveLink}>
            Schedule</NavLink></div>
            <div className={classes.NavigationItem}><NavLink to="/exhibition" exact activeClassName={classes.ActiveLink}>
            50 Years</NavLink></div>
        <div className={classes.NavigationItem}><NavLink to="/register" exact activeClassName={classes.ActiveLink}>
            Register</NavLink></div>
        <div className={classes.NavigationItem}><NavLink to="/contact" exact activeClassName={classes.ActiveLink}>
            Contact us</NavLink></div>
    </div>
}

export default Navigation;